export default __webpack_public_path__ + "static/media/Sweet.f9863a5b.png";